import {getPage} from '@packages/shared/utils/PageTreeUtils';
import {isComponentPage} from '@packages/shared/utils/PageUtils';
import {abilityFeature} from '../abilityFeature';

/**
 * Page type requirement config.
 * @property componentCanvas - true = require component page, false = require NOT component page
 * @example { pageTypes: { componentCanvas: false } } // Disable on component pages
 */
export type PageTypeRequirement = Partial<Record<'componentCanvas', boolean>>;

/**
 * Sub-selector that validates page type constraints.
 * Gates abilities based on current page type (e.g., prevent analyze mode on component pages).
 */
export const pageTypes = abilityFeature({
  key: 'pageTypes',
  isValid(state, config) {
    // Permissive defaults when stores unavailable
    const currentPageId = state.DesignerStore?.currentPageId;
    if (!currentPageId || !state.PageStore) return true;

    const currentPage = getPage(currentPageId, state.PageStore);
    if (!currentPage) return true;

    if (config.componentCanvas !== undefined) {
      return isComponentPage(currentPage) === config.componentCanvas;
    }

    return true;
  },
});
